import { axiosInstance } from '../request';
export const getMessageStatuses = async (messageId) => {
    const response = await axiosInstance.get(`/api/v1/messages/${messageId}/statuses`);
    return response.data;
};
//# sourceMappingURL=messages.api.js.map